import script from "./MyPropertyDetailComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MyPropertyDetailComponent.vue?vue&type=script&setup=true&lang=js"

import "./MyPropertyDetailComponent.vue?vue&type=style&index=0&id=3b1a10de&lang=css"

const __exports__ = script;

export default __exports__